import "./edit-waiver.scss";
import { FaChevronLeft } from "react-icons/fa6";
import { FormProvider } from "react-hook-form";
import { ConfirmDialog } from "primereact/confirmdialog";

import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderContent from "@shared/ui/header-content/header-content";
import HeaderButton from "@shared/ui/header-button/header-button";

import FormWaiver from "../form-waiver/form-waiver";
import { useEditWaiver } from "./edit-waiver.hook";
import PrintWaiver from "@domain/contract/print-waiver/print-waiver";
import { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";

export function EditWaiver() {
  const {
    waiverData,
    isLoading,
    waiverError,
    formMethod,
    actions,
    description,
    subtitle,
    name,
    fontSize,
    handleBack,
    handleAction,
  } = useEditWaiver();
  const [previewWaiver, setPreviewWaiver] = useState(false);

  const title = waiverData?.name ? (
    <h1>{waiverData?.name}</h1>
  ) : (
    <h1>Edit Waiver</h1>
  );
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormWaiver handleWaiverPreview={() => setPreviewWaiver(true)} />
      </section>
    </div>
  );
  const printWaiver = (
    <Dialog
      header="Waiver PReview"
      visible={previewWaiver}
      style={{ width: "50vw" }}
      onHide={() => {
        if (!previewWaiver) return;
        setPreviewWaiver(false);
      }}
    >
      <PrintWaiver
        fontSize={fontSize || 12}
        subTitle={subtitle || ""}
        title={name || ""}
        waiverText={description || ""}
        session={0}
        patient="Patient Name"
        doctor="Doctor Name"
        service="Service Name"
        signature={null}
      />
    </Dialog>
  );

  return (
    <div id="EditWaiver" className="waiver">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {printWaiver}
          {isLoading && displayLoading}
          {waiverError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditWaiver;
